import {
  SortableSectionHeader,
  SortDirections,
} from '@shared/components/sortable-section/models/sortable-section.model';

export enum HeaderName {
  USERNAME = 'userName',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  LAST_LOGIN = 'lastLogin',
}

export const MANAGE_USERS_HEADERS_DESKTOP: SortableSectionHeader[] = [
  {
    headerName: HeaderName.USERNAME,
    sortDirection: SortDirections.asc,
    displayText: 'i18n.manageUsers.username',
    size: 3,
    offset: 0.25,
  },
  {
    headerName: HeaderName.FIRST_NAME,
    displayText: 'i18n.manageUsers.firstName',
    sortDirection: SortDirections.asc,
    size: 1.5,
    offset: 0.25,
  },
  {
    headerName: HeaderName.LAST_NAME,
    displayText: 'i18n.manageUsers.lastName',
    sortDirection: SortDirections.asc,
    size: 1.5,
    offset: 0.25,
  },
  {
    headerName: HeaderName.EMAIL,
    displayText: 'i18n.manageUsers.email',
    sortDirection: SortDirections.asc,
    size: 2.75,
    offset: 0,
  },
  {
    headerName: HeaderName.LAST_LOGIN,
    displayText: 'i18n.manageUsers.lastLogin',
    sortDirection: SortDirections.asc,
    size: 1.75,
    offset: 0,
  },
];

export const MANAGE_USERS_HEADERS_TABLET: SortableSectionHeader[] = [
  {
    headerName: HeaderName.USERNAME,
    sortDirection: SortDirections.asc,
    displayText: 'i18n.manageUsers.username',
    size: 2.25,
    offset: 0.25,
  },
  {
    headerName: HeaderName.FIRST_NAME,
    displayText: 'i18n.manageUsers.firstName',
    sortDirection: SortDirections.asc,
    size: 1.5,
    offset: 0.25,
  },
  {
    headerName: HeaderName.LAST_NAME,
    displayText: 'i18n.manageUsers.lastName',
    sortDirection: SortDirections.asc,
    size: 1.5,
    offset: 0.25,
  },
  {
    headerName: HeaderName.EMAIL,
    displayText: 'i18n.manageUsers.email',
    sortDirection: SortDirections.asc,
    size: 2.25,
    offset: 0.25,
  },
  {
    headerName: HeaderName.LAST_LOGIN,
    displayText: 'i18n.manageUsers.lastLogin',
    sortDirection: SortDirections.asc,
    size: 3.25,
    offset: 0.25,
  },
];

export const MANAGE_USERS_HEADERS_MOBILE: SortableSectionHeader[] = [
  {
    headerName: HeaderName.USERNAME,
    displayText: 'i18n.manageUsers.username',
    sortDirection: SortDirections.asc,
    size: 8,
    offset: 0.25,
  },
  {
    headerName: HeaderName.LAST_LOGIN,
    displayText: 'i18n.manageUsers.lastLogin',
    sortDirection: SortDirections.asc,
    size: 3.75,
    offset: 0,
  },
];
